import { gql, useQuery } from '@apollo/client';

export const GET_PROCESS_TASK = gql`
  query getProcessTask($taskId: ObjectId!) {
    getProcessTask(taskId: $taskId) {
      _id
      title
      details
      createdBy
      assignTo
      type
      responsiblePersonsIds
      assignedByMember {
        _id
        profile {
          displayName
        }
      }
      responsiblePersons {
        _id
        profile {
          displayName
        }
      }
      dueTo
      status
      jobId
      companyId
      departmentId
      overdue
      description
      checklist {
        title
        completed
      }
      company {
        name
      }
      job {
        title
      }
      department {
        name
      }
    }
  }
`;

export const useGetProcessTask = (taskId?: string) => {
  const { data, loading } = useQuery(GET_PROCESS_TASK, {
    variables: { taskId },
    skip: !taskId,
    fetchPolicy: 'network-only',
  });

  const processTask = data?.getProcessTask || {};

  return { loading, processTask };
};
